import { gql } from '@apollo/client/core';

export const GET_BUILDABLE_TEMPLATE = gql`
    query GetBuildableTemplate($id: ID!) {
        buildableTemplate(id: $id) {
            id
            currentVersion {
                id
                thumbnailUrl
            }
            templateType
        }
    }
`;